var render = function () {
  var _vm$sale$image;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.sale ? _c('div', {
    staticClass: "factoid"
  }, [_c('GGLink', {
    staticClass: "factoid__img-wrap",
    style: ("background-image: url(" + ((_vm$sale$image = _vm.sale.image) === null || _vm$sale$image === void 0 ? void 0 : _vm$sale$image.x1) + ")"),
    attrs: {
      "to": _vm.sale.path
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "factoid__title"
  }, [_vm._v("\n    " + _vm._s(_vm.sale.name) + "\n  ")]), _vm._v(" "), _vm.description ? _c('div', {
    staticClass: "cc-p factoid__description"
  }, [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.sale.expiration ? _c('h5', {
    staticClass: "factoid__date-to"
  }, [_vm._v("\n    Акция продлится до " + _vm._s(_vm.getDate(_vm.sale.expiration)) + "\n  ")]) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }